import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogPercentComplete } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogCurrentItemIndex } from '@/redux/modules/console';

type Props = {
    catalogId: number;
    className?: string;
    /** Overrides the calculated fill. Pass `0` for an empty track. */
    percent?: number;
};

export const CatalogCardProgressBar = ({ catalogId, className, percent: percentOverride }: Props) => {
    const currentItemIndex = useAppSelector((state) => getLiveCatalogCurrentItemIndex(state, catalogId));
    const calculatedPercent = useAppSelector((state) => getCatalogPercentComplete(state, catalogId, currentItemIndex));
    const percent = percentOverride ?? calculatedPercent;

    return (
        <div className={cn('h-1 w-full bg-border-secondary', className)}>
            <div
                className="h-1 bg-critical-400 transition-all duration-200 ease-in"
                data-testid="catalog-card-progress-bar-inner"
                style={{ width: `${percent}%` }}
            />
        </div>
    );
};
